export function findAutomation(automations, retailerId, brandId) {
  return automations.find((x) => {
    return (
      String(x.brand_id) === String(brandId) &&
      String(x.retailer_id) === String(retailerId)
    )
  })
}

export function findRetailerForBrand(retailerAccount, brandId) {
  return retailerAccount.retailers.find((x) => {
    return String(x.brand_id) === String(brandId)
  })
}
